import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export
} from 'devextreme-react/data-grid';
import Request from "../../../components/api/Request";
import CustomStore from 'devextreme/data/custom_store';
import * as AppActions from '../../../actions/AppActions';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate, hasRole } from "../../../utils/Utils";
import './kullanici.scss';
import KullaniciDetay from './KullaniciDetay';
import KullaniciDomain from './KullaniciDomain';
import KullaniciRole from './KullaniciRole';




const Kullanici = () => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            listele: hasRole("tanimlar|kullanici|listele"),    
            goruntule: hasRole("tanimlar|kullanici|goruntule"),  
            ekle: hasRole("tanimlar|kullanici|ekle"),  
            degistir: hasRole("tanimlar|kullanici|degistir"),  
            sil: hasRole("tanimlar|kullanici|sil"),  
            domainList: hasRole("tanimlar|kullanici|domainList"),    
            roleList: hasRole("tanimlar|kullanici|roleList"),    
            userDomainSave: hasRole("tanimlar|kullanici|userDomainSave"),    
            userRoleSave: hasRole("tanimlar|kullanici|userRoleSave")
        });

    const listeBasligi = "Kullanıcı Tanım";
    const [store, setStore] = useState(null);
    const [kullaniciData, setKullaniciData] = useState({ popupState: false, data: [] });
    const [kullaniciDomainData, setKullaniciDomainData] = useState({ popupState: false, data: [] });
    const [kullaniciRoleData, setKullaniciRoleData] = useState({ popupState: false, data: [] });

    let dataGrid = null;

    useEffect(() => {
        yenile();
    }, []);

    const getStore = () => {
        return new CustomStore({
            key: 'id',
            load: function () {

                const request = new Request("/kullanici/getKayitList", "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }

    const yenile = () => {
        setStore(getStore());
    }

    function hideKullaniciDataPopup() {
        setKullaniciData({ popupState: false, data: {} })
        yenile();
    }
    function onToolbarPreparingDetay(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            //template: 'totalGroupCount'
        }, {
            location: 'after',
            widget: 'dxButton',
            visible: () => { return formYetki.ekle },
            options: {
                icon: 'add',
                onClick: () => {
                    addDetay(null);
                }
            }
        });
    }
    function addDetay(data) {
        setKullaniciData({ popupState: true, data: null })
    }
    function editDetay(data) {
        setKullaniciData({ popupState: true, data: data })
    }

    function hideKullaniciDomainDataPopup() {
        setKullaniciDomainData({ popupState: false, data: {} })
        yenile();
    }
    function hideKullaniciRoleDataPopup() {
        setKullaniciRoleData({ popupState: false, data: {} })
        yenile();
    }

    function openKullaniciDomainDataPopup(data) {
        setKullaniciDomainData({ popupState: true, data: data })
    }
    function openKullaniciRoleDataPopup(data) {
        setKullaniciRoleData({ popupState: true, data: data })
    }
    //test
    return (
        <div>
            <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    {/* <Button icon="plus" width={150} text="Yeni Kayıt" type={'success'} style={{ fontSize: "15px" }}></Button> */}
                </div>
            </div>

            <DataGrid
                className="kullaniciGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
                onToolbarPreparing={onToolbarPreparingDetay}
            //selection={{ mode: 'single', deferred: true }} 
            >
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />

                <Column type="buttons" caption={'İşlem'}
                    buttons={[
                        {
                            hint: 'Düzenle', icon: 'edit',
                            visible: () => { return formYetki.degistir },
                            onClick: (e) => { editDetay(e.row.data); }
                        },
                        {
                            hint: 'Firma Yetki', icon: 'columnchooser',
                            visible: () => { return formYetki.domainList },
                            onClick: (e) => { openKullaniciDomainDataPopup(e.row.data); }
                        },
                        {
                            hint: 'Role Yetki', icon: 'columnfield',
                            visible: () => { return formYetki.roleList },
                            onClick: (e) => { openKullaniciRoleDataPopup(e.row.data); }
                        },
                    ]}
                />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'username'} width={1500} caption={'Kullancı Adı'} dataType="string" visible={true} />
                <Column dataField={'state'} width={50} caption={'Durum'} dataType="boolean" visible={true} />
              
            </DataGrid>

            <Popup
                visible={kullaniciData.popupState}
                onHiding={hideKullaniciDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Kullanıcı Detay Bilgi"
                width={350}
                height={250}
            >
                <div>
                    {kullaniciData.popupState ? <KullaniciDetay data={kullaniciData.data} hide={hideKullaniciDataPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideKullaniciDataPopup}
                    />
                </div>
            </Popup>

            <Popup
                visible={kullaniciDomainData.popupState}
                onHiding={hideKullaniciDomainDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Kullanıcı Firma Bilgi"
                width={450}
                height={600}
            >
                <div>
                    {kullaniciDomainData.popupState ? <KullaniciDomain data={kullaniciDomainData.data} hide={hideKullaniciDomainDataPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideKullaniciDomainDataPopup}
                    />
                </div>
            </Popup>

            <Popup
                visible={kullaniciRoleData.popupState}
                onHiding={hideKullaniciRoleDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Kullanıcı Role Bilgi"
                width={450}
                height={450}
            >
                <div>
                    {kullaniciRoleData.popupState ? <KullaniciRole data={kullaniciRoleData.data} hide={hideKullaniciRoleDataPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideKullaniciRoleDataPopup}
                    />
                </div>
            </Popup>

        </div>
    );


}

export default Kullanici;
